module.exports = __webpack_public_path__ + "static/media/RI-D6-0.1-061.1e070fdb.webp";